import { useRef } from "react";
import { toast } from "../../lib/notify";
import { Users, Pencil, X, UserRound, Camera } from "lucide-react";
import { http, toastApiError, downloadUrl } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { cardTitle } from "./personnelShared";

// yuvarlak personel fotoğrafı: ekle / değiştir / sil (yalnız kayıtlı kartta)
function Avatar({ editing, form, setForm, load }) {
  const photoRef = useRef(null);
  const isEdit = editing !== "new";
  const upload = async (e) => {
    const f = e.target.files?.[0]; e.target.value = ""; if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    try { const { data } = await http.post(`/personnel/${editing}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } }); setForm((x) => ({ ...x, photo_ver: data.photo_ver })); toast.success("Fotoğraf kaydedildi"); load(); } catch (err) { toastApiError(err); }
  };
  const remove = async () => {
    if (!window.confirm("Fotoğraf silinsin mi?")) return;
    try { await http.delete(`/personnel/${editing}/photo`); setForm((x) => ({ ...x, photo_ver: "" })); load(); } catch (err) { toastApiError(err); }
  };
  return (
    <div className="relative shrink-0 group" data-testid="pf-avatar">
      {isEdit && form.photo_ver ? (
        <img src={downloadUrl(`/personnel/${editing}/photo?v=${form.photo_ver}`)} alt="Personel fotoğrafı" className="w-24 h-24 rounded-full object-cover border-2 border-orange-300 bg-white" data-testid="pf-photo" />
      ) : (
        <div className="w-24 h-24 rounded-full bg-slate-200 flex items-center justify-center"><UserRound className="w-12 h-12 text-slate-400" /></div>
      )}
      {isEdit && (
        <>
          <input ref={photoRef} type="file" accept="image/*" className="hidden" data-testid="pf-photo-input" onChange={upload} />
          <button type="button" onClick={() => photoRef.current?.click()} data-testid="pf-photo-add" title={form.photo_ver ? "Fotoğrafı değiştir" : "Fotoğraf ekle"} className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-orange-600 text-white flex items-center justify-center shadow hover:bg-orange-700"><Camera className="w-4 h-4" /></button>
          {form.photo_ver && <button type="button" onClick={remove} data-testid="pf-photo-remove" title="Fotoğrafı sil" className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-white border border-red-300 text-red-600 flex items-center justify-center shadow opacity-0 group-hover:opacity-100 transition-opacity"><X className="w-3.5 h-3.5" /></button>}
        </>
      )}
    </div>
  );
}

// kart başlığı: fotoğraf + ad/TC/giriş/çıkış özeti + başlık, Düzenle ve İptal (ESC de kapatır)
export default function PersonnelCardHeader({ editing, form, setForm, load, viewOnly, setViewOnly, onClose }) {
  return (
    <div className="flex items-start gap-4">
      <Avatar editing={editing} form={form} setForm={setForm} load={load} />
      <div className="text-sm font-bold text-slate-800 leading-6 uppercase" data-testid="pf-summary">
        <div>{form.full_name || "PERSONEL ADI SOYADI"}</div>
        <div className="font-mono">{form.tc_no || "TC NUMARASI"}</div>
        <div>{form.hire_date ? `İŞE GİRİŞ: ${fmtDate(form.hire_date)}` : "İŞE GİRİŞ"}</div>
        <div>{form.leave_date ? `İŞTEN ÇIKIŞ: ${fmtDate(form.leave_date)}` : "İŞTEN ÇIKIŞ"}</div>
      </div>
      <div className="ml-auto flex items-center gap-2 text-[10px] text-slate-500">
        <Users className="w-4 h-4 text-orange-600" /><span className="text-sm font-bold text-slate-800">{cardTitle(editing, viewOnly)}</span>
        {viewOnly && <button type="button" onClick={() => setViewOnly(false)} data-testid="pf-enable-edit" className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-orange-600 text-white text-xs font-semibold hover:bg-orange-700"><Pencil className="w-3.5 h-3.5" /> Düzenle</button>}
        <button type="button" onClick={onClose} data-testid="pf-close" title="Kartı kapat (ESC)" className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md border border-slate-300 bg-white text-xs font-semibold text-slate-700 hover:bg-slate-100"><X className="w-3.5 h-3.5" /> İptal <kbd className="ml-0.5 px-1 rounded border border-slate-300 bg-slate-50 text-[9px] font-mono text-slate-500">ESC</kbd></button>
      </div>
    </div>
  );
}
